'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  outline: none;\n  width: ', ';\n  min-height: 1px;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n  vertical-align: top;\n  white-space: normal;\n'], ['\n  outline: none;\n  width: ', ';\n  min-height: 1px;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n  vertical-align: top;\n  white-space: normal;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CardWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var width = _ref.width;
  return width + '%';
});

exports.default = CardWrapper;


//////////////////
// WEBPACK FOOTER
// ./~/react-styled-carousel/build/components/CardWrapper.js
// module id = 430
// module chunks = 35783957827783